export default {"onboardingInstructionsWrapper":"_onboardingInstructionsWrapper_1lvkw_1","onboardingInstructionsInner":"_onboardingInstructionsInner_1lvkw_11"};